<template>
  <v-app light>
    <v-toolbar
      app
      flat
      dense
      color="white"
    >
      <v-toolbar-title class="white--text" style="margin-left: 0">
        <router-link :to="{name: 'home'}">
          <v-img
            :src="require('@/assets/logo.png')"
            aspect-ratio="2"
            contain
            height="75"
            width="100"
            style="cursor: pointer"
          ></v-img>
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <div id="authenticate_btn">
        <v-btn class="blue--text" icon :to="{ path: '/login', query: { ref: $route.query.ref || $route.query.referral || '' } }" style="font-size: smaller">
          <i class="fa-solid fa-arrow-right-to-bracket fa-2x"></i>
          <div>Login</div>
        </v-btn>
        <v-btn class="red--text" icon :to="{ path: '/signup', query: { ref: $route.query.ref || $route.query.referral || '' } }" style="font-size: smaller">
          <i class="fa-solid fa-user-plus fa-2x"></i>
          <div>SignUp</div>
        </v-btn>
      </div>
    </v-toolbar>

    <v-content style="background-color: #ededed">
      <router-view/>
    </v-content>

    <!-- ============================================ -->
    <!-- SNACKBAR GLOBAL - TRÈS IMPORTANT -->
    <!-- ============================================ -->
    <v-snackbar
      v-model="$store.state.snackBar"
      :color="$store.state.snackBarColor"
      :timeout="$store.state.snackBarTimeOut"
      top
      right
      multi-line
    >
      <div style="white-space: pre-wrap;">{{ $store.state.snackBarMessage }}</div>
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="$store.commit('activateSnackBar', false)"
          color="white"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!-- ============================================ -->
    <!-- DIALOG GLOBAL - POUR LES MESSAGES D'AIDE -->
    <!-- ============================================ -->
    <v-dialog
      v-model="$store.state.dialog"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $store.state.dialog_title }}
        </v-card-title>
        <v-card-text>
          {{ $store.state.dialog_message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="$store.commit('activateDialog', false)"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_APP_NAME,
    }
  },
  mounted() {
    // Initialiser le store au chargement
    this.$store.commit('initialiseStore');
  },
  methods: {
    // Méthodes minimales requises
  },
}
</script>

<style>
div#authenticate_btn .v-btn .v-btn__content {
  display: flex;
  flex-direction: column;
}

.v-toolbar__title {
  font-size: 18px!important;
}

/* Style pour le snackbar avec texte multiligne */
.v-snack__wrapper {
  min-width: 300px;
  max-width: 500px;
}

.v-snack__content {
  padding: 14px 16px;
}
</style>